module.exports = __webpack_public_path__ + "img/service-1-shouhou.946bbbf6.png";